import React, { useEffect } from "react";
import "../popup.css";
import DeleteButton from "../../Buttons/DeleteButton";
import BackButton from "../../Buttons/BackButton";
import { gtmPush } from "../../../analytics/useGtmPageview.tsx";
const CancelIdentity = ({ onContinue, onCancel, onClose }) => {
  useEffect(() => {
    gtmPush("popup_open", {
      popup_id: "cancel_identity",
      popup_name: "Cancel Identity Clicked",
      trigger: "manual",
      page_path: window.location.pathname + window.location.search,
    });
  }, []);
  const handleOverlayClick = (e) => {
    // Only trigger cancel if user clicks directly on the overlay
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <h1 className="modal-title">Cancel my verified identity</h1>
        <p className="modal-text">
          If you cancel your verified identity you will not be able to use
          RealMe to easily prove who you are online.
        </p>
        <p className="modal-text">Are you sure you want to cancel?</p>
        <div className="modal-actions">
          <DeleteButton
            text={"Yes, cancel my verified identity"}
            onClick={onContinue}
          />
          <BackButton text={"Back"} onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default CancelIdentity;
